import React from "react";
import classNames from "classnames";
import pathToRegexp from "path-to-regexp";
import { history } from "store";
import { Layout, Menu, Tooltip, Icon } from "antd";
import { Link } from "react-router-dom";
import { at } from "lodash";

import { connect } from "react-redux";
import { logoutAction } from "store/auth/action";

import { getMenuItemAppliedRole } from "components/SiderMenu/RoleCombineToSliderMenu";

import { getLogoImage, getSmallLogoImage } from "services/axios";

import styles from "./index.module.less";

const { Sider } = Layout;

const { SubMenu } = Menu;

class SiderMenu extends React.PureComponent {
  state = {
    menuSelectedKeys: [],
    sideMenuItemList: []
  };

  componentDidUpdate(prevProps, prevState) {
    const { router } = this.props;
    const { sideMenuItemList } = this.state;
    const {
      location: { pathname }
    } = router;
    if (
      prevProps.router !== router ||
      sideMenuItemList !== prevState.sideMenuItemList
    ) {
      this._highlightSelectedMenuItem(pathname);
    }
  }

  componentDidMount() {
    const menuItemAppliedRole = getMenuItemAppliedRole();
    if (menuItemAppliedRole)
      this.setState({ sideMenuItemList: getMenuItemAppliedRole() });
    else {
      this.props.logout();
    }
  }

  _highlightSelectedMenuItem = pathname => {
    const { sideMenuItemList } = this.state;
    const menuSelectedKeys = [];
    sideMenuItemList.forEach(item => {
      if (item.hasChildren) {
        item.children.forEach(sub => {
          const subRegexp = pathToRegexp(`/${item.path}${sub.path}(.*)`);
          if (subRegexp.test(pathname)) {
            menuSelectedKeys.push(`${item.key}/${sub.key}`);
          }
        });
      }
      const pathRegexp = pathToRegexp(`${item.path}(.*)`);
      if (pathRegexp.test(pathname)) {
        menuSelectedKeys.push(item.key + "");
      }
    });
    if (menuSelectedKeys.length > 0) {
      this.setState({
        menuSelectedKeys
      });
    } else {
      this.setState({
        menuSelectedKeys: [at(sideMenuItemList, "[0].key")[0]]
      });
    }
  };

  _onMenuItemClick = path => () => {
    const { toggleMenuCollapse, isMobile } = this.props;
    if (path) {
      history.replace(path);
      if (isMobile) {
        toggleMenuCollapse();
      }
    }
  };

  render() {
    const { menuSelectedKeys, sideMenuItemList } = this.state;
    const {
      isMobile,
      theme,
      collapsed,
      fixSiderbar,
      width,
      router
    } = this.props;
    const siderClassName = classNames(styles.sider, {
      [styles.fixSiderBar]: fixSiderbar,
      [styles.light]: theme === "light"
    });
    const {
      location: { pathname }
    } = router;
    let defaultKey = "";
    const urlObj = pathname.trim().split("/");

    if (urlObj.length > 2) {
      defaultKey = urlObj[1];
    }
    return (
      <Sider
        collapsedWidth={isMobile ? 0 : 80}
        className={siderClassName}
        trigger={null}
        theme={theme || "light"}
        collapsible
        collapsed={collapsed}
        width={width}
      >
        <div className={styles.logo}>
          <Tooltip title="Home" placement="right">
            <Link to="/">
              <img
                className="img-fluid"
                alt=""
                src={collapsed ? getSmallLogoImage() : getLogoImage()}
              />
            </Link>
          </Tooltip>
        </div>
        <Menu
          theme={theme || "light"}
          defaultSelectedKeys={["1"]}
          selectedKeys={menuSelectedKeys}
          defaultOpenKeys={[defaultKey]}
          mode="inline"
        >
          {sideMenuItemList.map(item => {
            if (item.hasChildren) {
              return (
                <SubMenu
                  inlineCollapsed={true}
                  key={item.key}
                  title={
                    <span>
                      <Icon type={item.icon} />
                      <span style={{ display: collapsed ? "none" : "initial" }}>
                        {item.title}
                      </span>
                    </span>
                  }
                >
                  {item.children.map(sub => {
                    return (
                      <Menu.Item
                        key={`${item.key}/${sub.key}`}
                        onClick={this._onMenuItemClick(
                          `/${item.path}${sub.path}`
                        )}
                      >
                        <Icon type={sub.icon} />
                        <span>{sub.title}</span>
                      </Menu.Item>
                    );
                  })}
                </SubMenu>
              );
            }
            return (
              <Menu.Item
                key={item.key}
                onClick={this._onMenuItemClick(item.path)}
              >
                <Icon type={item.icon} />
                <span>{item.title}</span>
              </Menu.Item>
            );
          })}
        </Menu>
      </Sider>
    );
  }
}
// export default SiderMenu;

const mapDispatchToProps = {
  logout: logoutAction
};

export default connect(
  null,
  mapDispatchToProps
)(SiderMenu);
